



















































import Vue from "vue";
const gauge = require('vue-svg-gauge');  
const { VueSvgGauge } = gauge;

export default Vue.extend({
	components: {
		VueSvgGauge
	},
	props: ["title", "value", "svgImage", "change"],

	data() {
		return {
			
		};
	},

	computed: {
		
	},

	methods: {

	},
		
	mounted() {
		
	},
	watch: {
		
	}
});
